import { View, Text } from "react-native";
import React from "react";
import RenderHtmlComponent from "components/RenderHtml";

const PlanDescriptionComponent = ({ description }: { description: string }) => {
  return (
    <View>
      <Text style={{ marginBottom: 10, fontWeight: "700" }}>Plan details</Text>
      <RenderHtmlComponent source={description || ""} />
    </View>
  );
};

export default PlanDescriptionComponent;
